// src/menu-items/admin.jsx

import { ROLES } from '../lib/auth/roles';
import CampaignIcon from '@mui/icons-material/Campaign';
import PaymentsIcon from '@mui/icons-material/Payments';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import EventIcon from '@mui/icons-material/Event';
import MessageIcon from '@mui/icons-material/Message';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import RouteIcon from '@mui/icons-material/Route';
import UpcomingIcon from '@mui/icons-material/Upcoming';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import CakeIcon from '@mui/icons-material/Cake';
import TableBarIcon from '@mui/icons-material/TableBar';
import StorefrontIcon from '@mui/icons-material/Storefront';

const admin = {
  id: 'group-admin',
  title: 'Management',
  type: 'group',
  children: [
    {
      id: 'admin-payments',
      title: 'Host Payouts',
      type: 'item',
      url: '/admin/payments',
      icon: () => <PaymentsIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'admin-announcements',
      title: 'Announcements',
      type: 'item',
      url: '/admin/annoucements',
      icon: () => <CampaignIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'admin-app-popups',
      title: 'App Popups',
      type: 'item',
      url: '/admin/AppPopups',
      icon: () => <UpcomingIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'admin-special-events',
      title: 'Special Events',
      type: 'item',
      url: '/admin/specialEvents',
      icon: () => <EventIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'admin-birthdays',
      title: 'Birthdays',
      type: 'item',
      url: '/admin/birthdays',
      icon: () => <CakeIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'admin-host-requests',
      title: 'Host Requests',
      type: 'item',
      url: '/admin/host-requests',
      icon: () => <GroupAddIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN, ROLES.MANAGEMENT]
    },
    {
      id: 'sms',
      title: 'SMS',
      type: 'item',
      url: '/admin/sms',
      icon: () => <MessageIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'dinner-bookings',
      title: 'Dinner Bookings',
      type: 'item',
      url: '/admin/dinnerBookings',
      icon: () => <RestaurantMenuIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'booth-settings',
      title: 'Booth Settings',
      type: 'item',
      url: '/admin/booth-settings',
      icon: () => <TableBarIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN, ROLES.MANAGEMENT]
    },
    {
      id: 'public-rsvp',
      title: 'Public RSVP',
      type: 'item',
      url: '/admin/public-rsvp',
      icon: () => <HowToRegIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'business-guestlist',
      title: 'Business Guestlist',
      type: 'item',
      url: '/admin/business-guestlist',
      icon: () => <StorefrontIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN, ROLES.MANAGEMENT]
    },
    {
      id: 'public-host-onboarding',
      title: 'Host Onboarding',
      type: 'item',
      url: '/admin/public-host-onboarding',
      icon: () => <GroupAddIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN, ROLES.MANAGEMENT]
    },
    {
      id: 'front-door-rules',
      title: 'Front Door Rules',
      type: 'item',
      url: '/admin/front-door-rules',
      icon: () => <MeetingRoomIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'host-photo-report-email-settings',
      title: 'Host Report Emails',
      type: 'item',
      url: '/admin/host-photo-report-emails',
      icon: () => <MarkEmailReadIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    },
    {
      id: 'posh-event-mapping',
      title: 'Posh Event Mapping',
      type: 'item',
      url: '/admin/poshEventMapping',
      icon: () => <RouteIcon sx={{ fontSize: 21 }} />,
      allowedRoles: [ROLES.ADMIN]
    }
  ]
};

export default admin;
